package one.healthium.fodmap.providers

import ifaandroid.apps.fodmap.composeapp.generated.resources.Res
import one.primehealth.app.BaseAppResourceProvider

class AppResourceProvider : BaseAppResourceProvider {
    override suspend fun readBytes(path: String): ByteArray {
        return Res.readBytes(path)
    }
}